// extracted by mini-css-extract-plugin
module.exports = {"duoSpacing":"DuoSpacing_duoSpacing__ZDp8u"};